import React from 'react'
import { makeStyles } from '@material-ui/styles'
import {
  Typography,
} from '@material-ui/core'
import { capitalizeTitle } from '../../utils/Strings'

const useStyles = makeStyles(theme => ({
  cardTitle: {
    color: theme.palette.primary.main,
  },
  bold: { fontWeight: theme.typography.fontWeightBold },
}))

const ClauseTitle = ({ title, date, ...inputProps }) => {
  const classes = useStyles()
  return (
    <Typography
      variant="body1"
      component="p"
      className={`${classes.cardTitle} ${classes.bold}`}
      {...inputProps}
    >
      {date
        ? `${capitalizeTitle(title)} - ${date}`
        : capitalizeTitle(title)
      }
    </Typography>
  )
}

export default ClauseTitle
